import { useQuery } from '@tanstack/react-query';
import api from '@pasqal/core/api';

/**
 * Get the list of the projects the user is a member of or is invited to
 */
export const useProjects = () => {
  return useQuery({
    queryKey: ['projects'],
    queryFn: async () => {
      const response = await api.projects.fetchProjects({
        pagination: { activePage: 0, itemsPerPage: 100 }
      });
      return response.data ?? [];
    }
  });
};
